import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function MidCTA() {
  return <section className="py-12 px-4 bg-salvia-light/30" data-id="element-156" data-mp="hhgr4w7yew3o">
      <div className="max-w-4xl mx-auto text-center" data-id="element-157" data-mp="mhl80ncrxsuf">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-158" data-mp="miw8ad70gigs">
          <Button href="https://360yoga.impultienda.ar/checkout" className="text-lg md:text-xl py-4 px-8 shadow-lg" data-id="element-159" data-mp="3ux4vt6uoej23">
            👉 BASTA DE IMPROVISAR — QUIERO MI YOGA 360
          </Button>
        </motion.div>
      </div>
    </section>;
}